import { init as storeInit, RematchDispatch, RematchRootState } from '@rematch/core';
import createLoadingPlugin, { ExtraModelsFromLoading } from '@rematch/loading';
import immerPlugin from '@rematch/immer';
import selectPlugin from '@rematch/select';

import { createLogger } from 'redux-logger';

// shared model
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import { isDevelopment, isProduction, isQuietMode } from '@shared/utils/envHelper';
import { models, RootModel } from './index';

export const history = createBrowserHistory();
const reducers = {
  router: connectRouter(history),
};

const logger = createLogger({
  predicate: (getState, action) =>
    !['loading/show', '@@redux/REPLACE ', 'counter/count', 'loading/hide', '@@router/LOCATION_CHANGE'].includes(
      action.type,
    ),
  collapsed: true,
});

const reduxMiddlewares = [logger, routerMiddleware(history)];

if ((isDevelopment() && isQuietMode()) || isProduction()) {
  reduxMiddlewares.shift();
}
type FullModel = ExtraModelsFromLoading<RootModel>;

const store = storeInit<RootModel, FullModel>({
  models,
  plugins: [createLoadingPlugin(), immerPlugin(), selectPlugin()],
  redux: {
    reducers,
    middlewares: reduxMiddlewares,
  },
});

export const { select } = store;
export default store;
export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
